import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EditorComponentBase, GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

interface IOption {
    id: number;
    name: string;
}

@Component({
    selector: 'app-custom-field-list-options-editor',
    templateUrl: './custom-field-list-options-editor.component.html',
    styleUrls: ['./custom-field-list-options-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent, ValidationErrorMessageComponent]
})
export class CustomFieldListOptionsEditorComponent extends EditorComponentBase<string[] | null> implements OnInit {
    listSelectedOptions?: IOption[];

    constructor() {
        super();
    }

    ngOnInit(): void {
        if (this.bindingProperty !== null) {
            this.listSelectedOptions = this.bindingProperty ? this.toIOptionFormat(this.bindingProperty) : [];
        }
    }

    onListSelectedOptionsChange(event: any[]) {
        this.bindingProperty = event.length ? event.map((item) => item.name) : [];
        this.valueChange.emit();
        this.validate();
    }

    private toIOptionFormat(options: string[]) {
        return options.map((option) => ({ id: 0, name: option }));
    }
}
